export default function AuroraBackground() {
  return (
    <>
      <div className="hp-aurora" aria-hidden="true" />
      <div className="hp-arc hp-arc--tr" aria-hidden="true" />
      <div className="hp-arc hp-arc--bl" aria-hidden="true" />
      <div className="hp-grain" aria-hidden="true" />
    </>
  );
}
